import axios from 'axios';
import { baseUrl, token } from '../../../../services/Apis';

export const planevaTemasApi = `${baseUrl}/planeva-temas`;

export const allPlanevaTemasService = async (params) => {
  const res = await axios.get(planevaTemasApi, {
    headers: token({}),
    params,
  });
  return res;
};

export const savePlanevaTemasService = async (id, data) => {
  let res;
  if (id) {
    res = await axios.patch(`${planevaTemasApi}/${id}`, data, {
      headers: token({}),
    });
  } else {
    res = await axios.post(planevaTemasApi, data, {
      headers: token({}),
    });
  }
  return res;
};

export const onePlanevaTemasService = async (id) => {
  const res = await axios.get(`${planevaTemasApi}/${id}`, {
    headers: token({}),
  });
  return res;
};

export const deletePlanevaTemasService = async (id) => {
  const res = await axios.delete(`${planevaTemasApi}/${id}`, {
    headers: token({}),
  });
  return res;
};
